import React, { useState } from 'react';
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export interface PasswordFieldProps {
  label: string;
  name: string;
  value: string;
  error: string | undefined;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(
      field: T,
    ): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  label,
  name,
  value,
  error,
  handleChange,
}) => {
  const [passwordShow, setPasswordShow] = useState(false);
  function handleShowChange() {
    setPasswordShow(!passwordShow);
  }

  return (
    <FormControl
      className="sign-up-input"
      variant="outlined"
      sx={{ width: '100%' }}
      error={!!error}
    >
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <OutlinedInput
        id={name}
        name={name}
        type={passwordShow ? 'text' : 'password'}
        value={value}
        onChange={handleChange}
        aria-describedby="component-helper-text"
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={handleShowChange}
              edge="end"
            >
              {passwordShow ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        label={label}
      />
      {error && (
        <FormHelperText id="component-helper-text">{error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default PasswordField;
